import React, { useEffect, useState } from "react";
import apiAgent from "../../../app/api/apiAgent";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import { DataTableCompDynamicD } from "../../../app/common/common-components/OMSDatatables";
import NewDealDialog from "@/features/header/components/NewDealDialog";

const DealGrid = ({ actions, filterData, menuName = "", loopFilterOpen }) => {
  const [isNewDealDialogOpen, setIsNewDealDialogOpen] = useState(false);

  const [extraParams, setExtraParams] = useState(JSON.stringify(filterData));

  useEffect(() => {
    setExtraParams(JSON.stringify(filterData));
  }, [filterData]);

  const loadGrid = (requestParams) => {
    return apiAgent.Deal.dealDynamicAjax(
      requestParams,
      filterData.AgentId,
      filterData.PipelineId,
      filterData.WorkspaceAgentId,
      filterData.WorkspacePipelineId,
      filterData.PropertyTypes,
      filterData.Areas,
      filterData.RegistrationStartFrom,
      filterData.RegistrationEndTo,
      filterData.NeedUpdate,
      filterData.StageId,
      filterData.InternalDealTags
    );
  };

  const onCreateDealClick = (e) => {
    setIsNewDealDialogOpen(true);
  };

  const handleRowClick = (data) => {};

  return (
    <>
      <NewDealDialog isOpen={isNewDealDialogOpen} onClose={() => setIsNewDealDialogOpen(false)} />
      <div className="row mt-2">
        <div className="col-md-11 col-sm-12">
          <div className="panel panel-default panel-table oms-box">
            <div className="panel-heading">
              <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-12">
                  <div className="form-inline form-group">
                    <div className="element">
                      <div className="truncate">
                        <label>
                          <i className="fa fa-filter" aria-hidden="true"></i>
                          &nbsp;
                        </label>
                        <a className="filter-text" onClick={() => loopFilterOpen()}>
                          <span>
                            <b>Filter: </b>
                            {filterData.getFilterStringFull()}
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                {actions.indexOf("create") != -1 && (
                  <div className="col-md-6 col-sm-6 col-xs-12">
                    <div className="pull-right boxRightMenu">
                      <div className="form-inline">
                        <OMSButtonStyleL
                          type="button"
                          ui_icon=""
                          ui_type="create"
                          ui_text="add deal"
                          ui_processing_text=""
                          processing={false}
                          disabled={false}
                          onClick={onCreateDealClick}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="panel-body">
              <div style={{ marginBottom: "30px" }}>
                <DataTableCompDynamicD id="dealTable" onRowClick={handleRowClick} makeAjaxRequest={loadGrid} ExtraParams={extraParams} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DealGrid;
